module.exports = __webpack_public_path__ + "static/media/internet-of-things01.50da039f.jpg";